/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {CalendarWeekTask} from './calendar-week-task';
import {CalendarUtils} from './calendar-utils';
import {Dayjs} from 'dayjs';

export class CalendarWeekTool {
  public weekTasks: CalendarWeekTask[];
  public currentDate: Dayjs;

  constructor(currentDate: Dayjs, weekDayCount = 7) {
    this.currentDate = currentDate;
    const weekCount = CalendarUtils.getWeekCountOfMonth(this.currentDate);
    this.weekTasks = [];
    for (let i = 0; i < weekCount; ++i) {
      this.weekTasks[i] = new CalendarWeekTask(weekDayCount);
    }
  }

  public getLine(dayCount: number, startOfWeek: number, week: number): number {
    return this.weekTasks[week].getLine(startOfWeek, dayCount);
  }
}
